import PropTypes from 'prop-types';

import {renderCountriesForExcelExport, renderPostalCodes} from '@modules/blackoutZone/utils/blackoutZone';

export const exportExcel = (dataExport) => ({
    dataExport: dataExport,
    filename: 'blackout_zones',
    parseData: blackoutZone => [
        blackoutZone.id,
        blackoutZone.name,
        blackoutZone.description,
        renderCountriesForExcelExport(blackoutZone),
        renderPostalCodes(blackoutZone),
    ],
    path: 'blackoutZones.index.path',
    titles: [
        'ID',
        'Name',
        'Description',
        'Countries and Subdivisions',
        '#Postal codes',
    ],
});

exportExcel.propTypes = {
    dataExport: PropTypes.array.isRequired,
};
